<template>
  <div class="layout ex_reg_wrap">
      <van-form @submit="onSubmit" class="ex_reg_user_form" scroll-to-error error-message-align="right" input-align="right">
        <van-field
          v-model="userForm.nickname"
          name="nickname"
          label="姓名"
          placeholder="请输入姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          v-model="userForm.phone"
          name="phone"
          type="digit"
          label="手机"
          placeholder="请输入手机号"
          :rules="[{required:true,validator:validatorPhone, message: '请输入正确手机号' }]"
        />
        <van-field
          v-model="userForm.code"
          type="digit"
          name="code"
          label="验证码"
          :rules="[{required:true,message:'请输入验证码'}]"
        >
         <template #button>
          <span class="send_code" v-if="timer" style="color:#999;">{{ count || 0}}s</span>
          <span @click="send" class="send_code"   v-else>发送验证码</span>
         </template>
        </van-field>
        <van-field v-model="userForm.companyName"
                   name="companyName"
                   label="公司"
                   placeholder="请输入"
                   :rules="[{ required: true, message: '请填写公司' }]"/>
        <van-field v-model="userForm.jobTitle"
                   name="jobTitle"
                   label="职务"
                   placeholder="请输入"
                   :rules="[{ required: true, message: '请填写职务' }]"/>
        <van-field
          readonly
          clickable
          name="proType"
          :value="userForm.proType"
          label="产品类别"
          placeholder="点选择"
          right-icon="arrow"
          @click="showProType = true"
        />
        <van-popup v-model="showProType" position="bottom">
          <van-picker
            show-toolbar
            :columns="ProTypeList"
            @confirm="onProType"
            @cancel="showProType = false"
          />
        </van-popup>
        <div class="rules_consent">
          <van-checkbox v-model="userForm.isConsent" checked-color="#f85b0f" icon-size="0.28rem" shape="square" />
          <p @click.self="userForm.isConsent=!userForm.isConsent">我已阅读并同意展商秀<span @click.stop="showRules=true">《注册服务条款》</span></p>
        </div>
        <van-action-sheet class="rules_sheet" v-model="showRules" title="注册服务条款"  cancel-text="确定">
          <div class="content">
            <p>平等原则：</p>
            根据《中华人民共和国合同法》第三条:“合同当事人的法律地位平等,一方不得将自己的意志强加给另一方”的规定，平等原则是指地位平等的合同当事人，在充分协商达成一致意思表示的前提下订立合同的原则。这一原则包括三方面内容：①合同当事人的法律地位一律平等。不论所有制性质，也不问单位大小和经济实力的强弱，其地位都是平等的。②合同中的权利义务对等。当事人所取得财产、劳务或工作成果与其履行的
            义务大体相当；要求一方不得无偿占有另一方的财产，侵犯他人权益；要求禁止平调和无偿调拨。③合同当事人必须就合同条款充分协商，取得一致，合同才能成立。任何一方都不得凌驾于另一方之上，不得把自己的意志强加给另一方，更不得以强迫命令、胁迫等手段签订合同。
            <p>自愿原则：</p>
            根据《中华人民共和国合同法》第四条：“当事人依法享有自愿订立合同的权利，任何单位和个人不得非法干预”的规定，民事活动除法律强制性的规定外，由当事人自愿约定。包括：第一，订不订立合同自愿；第二，与谁订合同自愿，；第三，合同内容由当事人在不违法的情况下自愿约定；第四，当事人可以协议补充、变更有关内容；第五，双方也可以协议解除合同；第六，可以自由约定违约责任，在发生争议时，当事人可以自愿选择解决争议的方式。
            </div>
        </van-action-sheet>
        <van-button class="sumbit_btn" color="#f85b0f" block type="info" native-type="submit">保存并提交</van-button>
      </van-form>
  </div>
</template>

<script>
import moment from "moment"
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "registry",
  components:{
  },
  data() {
    return {
      userForm:{
        jobTitle:'',       //职务
        name:'',  //昵称
        companyName:'', //公司名称
        phone:'',     //手机
        code:'',      //验证码
        proType:'',       //产品类别
        isConsent:true, //用户是否同意
      },
      showProType:false,  //称谓选择框
      showRules:false,  //服务条款
      ProTypeList:['生活用品','化妆','食品'],
      count:0,
      timer:null
    } 
  },
  mounted(){
  },
  methods:{
    ...mapActions({
      sendCode: "login/sendCode",
      validateCode: "login/validateCode",
    }),
    //手机号校验
    validatorPhone(val){
      return /^1[3456789]\d{9}$/.test(val);
    },
    //产品类别选择
    onProType(val){
      this.userForm.proType=val;
      this.showProType=false;
    },
    //表单提交
    onSubmit(values){
      console.log(values);
    },
    //发送验证码
    async send(){
      if(!this.validatorPhone(this.userForm.phone))
      {
        return 
      }
      this.$toast.loading({
        message: '发送中...',
        forbidClick: true,
      });
      this.downTime();
      let res = await this.sendCode({
        phone: this.userForm.phone
      });
      if (res && res.Data.result) {
        this.$toast.success('已发送');
      } else {
        this.$toast.fail("发送失败！");
      }
    },
    //倒计时
    downTime() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        const timer = setInterval(() => {
          let count = this.count;
          if (count > 0 && count <= TIME_COUNT) {
            count--;
            this.count = count;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
        this.timer = timer;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.ex_reg_wrap{
    background: #131825;
    padding:0 0.24rem;
    .ex_reg_user_form{
      &::v-deep .van-cell{
        background: transparent;
        color: #fff;
        padding:0.3rem 0;
        border-bottom: 1px solid #1d2435;
        font-size: 0.3rem;
        &::after{
          display: none;
        }
        .van-cell__value{ 
          .van-field__body{
            .van-field__control{
              font-size: 0.3rem;
              color: #bfbfbf;
            }
            .send_code{
              font-size: 0.3rem;
              color: #f85b0f;
            }
            .van-field__right-icon{
              padding: 0 0.2rem 0 0;
              i{
                font-size: 0.24rem;
              }
            }
          }
          .van-field__error-message{
            position: absolute;
            right: 0;
            top:0.35rem;
          }
        }
        .van-cell__title{
          span{
            font-size: 0.3rem;
          }
        }
      }
      >p{
        font-size: 0.3rem;
        color: #fff;
        line-height: 1;
        padding: 0.35rem 0 0.2rem;
      }
      .sumbit_btn{
        font-size: 0.36rem;
        height: 0.98rem;
        line-height: 0.98rem;
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        border-radius: 0;
        span{
          font-size: 0.36rem;
        }
      }
      .rules_consent{
        margin-top: 0.5rem;
        display: flex;
        line-height: 0.3rem;
        p{
          margin-left: 0.18rem;
          font-size: 0.3rem;
          color:#565658;
          span{
            color:#f85b0f ;
          }
        }
        &::v-deep .van-checkbox{
          .van-checkbox__icon{
            border-radius:2px;
            overflow: hidden;
          }
        }
      }
      .rules_sheet{
        border-radius: 0.15rem 0.15rem 0 0;
        max-height:50%;
        &::v-deep .van-action-sheet__content{
          padding:0 0.2rem 0.2rem;
          .content{
            font-size: 0.28rem;
          }
        }
      }
  }
}
</style>
